import { ChevronDown, FileUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/common/components/Button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/common/components/Dropdown';

import * as styles from './styles';

type ExportDropdownProps = {
  onExport?: (exportOption: string) => void;
  isDrawer?: boolean;
  defaultValue?: string;
  disabled?: boolean;
};

export function ExportDropdown({
  onExport,
  isDrawer,
  defaultValue,
  disabled = false,
}: ExportDropdownProps) {
  const { t } = useTranslation('common');

  const handleExport = (value: string) => {
    if (!onExport) return;

    onExport(value);
  };

  const OPTIONS = [
    { value: 'csv', label: t('csv') },
    { value: 'pdf', label: t('pdf') },
    { value: 'xlsx', label: t('xlsx') },
  ];

  return (
    <>
      {defaultValue ? (
        <Button
          isDropDown
          disabled={disabled}
          text={t('export')}
          leadingIcon={<FileUp className={styles.icon()} size="18" />}
          onClick={() => handleExport(defaultValue)}
          size="small"
          variant="secondary"
        />
      ) : (
        <DropdownMenu>
          {isDrawer ? (
            <DropdownMenuTrigger>
              <button
                disabled={disabled}
                type="button"
                className={styles.button()}
              >
                <FileUp className={styles.icon()} size="18" />
                {t('export')}
                <ChevronDown className={styles.icon()} size="20" />
              </button>
            </DropdownMenuTrigger>
          ) : (
            <DropdownMenuTrigger>
              <Button
                isDropDown
                text={t('export')}
                disabled={disabled}
                leadingIcon={<FileUp className={styles.icon()} size="18" />}
                trailingIcon={
                  <ChevronDown className={styles.icon()} size="20" />
                }
                size="small"
                variant="secondary"
              />
            </DropdownMenuTrigger>
          )}

          <DropdownMenuContent className="z-[200] min-w-[11rem]">
            <DropdownMenuRadioGroup onValueChange={handleExport}>
              {OPTIONS?.map(option => (
                <DropdownMenuRadioItem key={option.value} value={option.value}>
                  {option.label}
                </DropdownMenuRadioItem>
              ))}
            </DropdownMenuRadioGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </>
  );
}
